module.exports = __webpack_public_path__ + "img/interstitial_logo_events.aa91ab3b.png";